import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef
} from '@angular/core';
import { HistoricalChartComponent } from 'app/charts-dashboard/components/charts/historical-chart/historical-chart.component';
import { ChartsCommonService } from 'app/charts-dashboard/services/charts-common.service';
import { ChartsDashboardQuery } from 'app/charts-dashboard/state/dashboard';
import {
  ChartsDashboardSeriesQuery,
  IChartSeries
} from 'app/charts-dashboard/state/series';
import { ChartsDashboardCardQuery } from 'app/charts-dashboard/state/card';
import { ChartsHttpService } from 'app/charts-dashboard/services/charts-http.service';
import {
  AxisXHistorical,
  ChartFilterPatternNameEnum,
  Datetime,
  IChartFilter,
  IChartPointsResponse,
  IIvxHistoryChartParameters,
  IMappedSeriesPointsResponse
} from 'app/charts-dashboard/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from 'app/core/services/common.service';
import { LineSeries } from '@arction/lcjs';
import { ChartsDashboardStateService } from 'app/charts-dashboard/state/charts-dashboard-state.service';

@Component({
  selector: 'iv-live-ivx-history',
  templateUrl: '../common-chart/common-chart.component.html',
  styleUrls: ['../common-chart/common-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvxHistoryComponent extends HistoricalChartComponent {

  constructor(
    protected readonly commonService: CommonService,
    protected readonly chartsCommonService: ChartsCommonService,
    protected readonly elementRef: ElementRef,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    protected readonly dashboardQuery: ChartsDashboardQuery,
    protected readonly seriesQuery: ChartsDashboardSeriesQuery,
    protected readonly cardsQuery: ChartsDashboardCardQuery,
    protected readonly httpService: ChartsHttpService,
    protected readonly chartDashboardState: ChartsDashboardStateService
  ) {
    super(commonService, chartsCommonService, elementRef, changeDetectorRef, dashboardQuery, seriesQuery, cardsQuery, httpService, chartDashboardState);
  }

  protected setCursorResultTableFormatter(lineSeries: LineSeries, series: IChartSeries, filters?: IChartFilter[]): void {
    super.setCursorResultTableFormatter(
      lineSeries,
      series,
      [this.card.filters.find((filter: IChartFilter) => filter.parameterId === ChartFilterPatternNameEnum.IVX_TERM)]
    );
  }

  protected createSeriesObservables(seriesArr: IChartSeries[], isFirstLoad?: boolean): Observable<IMappedSeriesPointsResponse<AxisXHistorical>>[] {
    return seriesArr.map((series: IChartSeries) => {
      return this.httpService.getIvxHistory(this.getChartsParams(series, isFirstLoad) as IIvxHistoryChartParameters)
        .pipe(map((data: IChartPointsResponse<AxisXHistorical>) => {
          return {
            ...data,
            seriesId: series.id
          };
        }));
    });
  }

  protected getChartsParams(series: IChartSeries, isFirstLoad?: boolean): IIvxHistoryChartParameters {
    if (!series) return;

    let from: Datetime;

    if (!isFirstLoad) {
      from = this.getFrom(series);
    }

    return {
      stockId: series.stock.stockId.toString(),
      symbol: series.stock.symbol,
      hasOptions: true,
      from,
      timeRange: series.selectedFilters.timeRange.name,
      ivxTerm: series.selectedFilters.ivxTerm.name,
      sendUserMetrics: !this.isSentUserMetrics && this.mainSeries.id === series.id
    };
  }
}
